export default "__VITE_ASSET__lK_bIioI__"